// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","681":"indikator-mutu"}[chunkId] + "." + {"443":"3cc3a934","681":"5f46237f"}[chunkId] + ".js";
};